import { Vue, Component } from 'vue-property-decorator'
import PageHeader from '~/components/page/PageHeader'
import SectionHelper from '~/utils/sectionHelper'
import LinkItem from '~/types/LinkItem'
import ProductList from '~/components/block/ProductList'
import LinkPaginate from '~/components/element/LinkPaginate'
import HeaderType from '~/types/enum/HeaderType'
import FilterProduct from '~/components/block/filter/FilterProduct'
import loc from '~/utils/loc'
import s from '~/utils/s'
import mainBreadcrumbsSubmenuItems from '~/utils/mainBreadcrumbsSubmenuItems'
import catalogSubmenuItems from '~/utils/catalogSubmenuItems'

@Component
export default class LandingPage extends Vue {
  isShow = true

  mounted () {
    const seo = s(this.$store).landingPage.landingPage.seo?.find(e => e.regionId === s(this.$store).regions.regionId)
    if (seo) {
      s(this.$store).seo.setTitle(seo.title)
      s(this.$store).seo.setDescription(seo.description)
      s(this.$store).seo.setKeywords(seo.keywords)
    }
  }

  get breadcrumb (): LinkItem[] {
    const sections = s(this.$store).categoryPage.pathSections
    const helper = new SectionHelper(s(this.$store).general.sections, this.$store)
    const breadcrumb = sections.map((e) => {
      if (e.alternativeDisplay === false) {
        return {
          title: e.name,
          location: helper.getSectionPathById(e.id) ?? '/catalog',
          submenuItems: catalogSubmenuItems(this.$store, e.name)
        }
      } else {
        return {
          title: e.name,
          location: loc(this.$store, {
            name: 'categories-id',
            params: {
              id: e.id
            }
          }),
          submenuItems: catalogSubmenuItems(this.$store, e.name)
        }
      }
    })
    return [
      {
        title: 'Главная',
        location: loc(this.$store, {
          name: 'index'
        }),
        submenuItems: mainBreadcrumbsSubmenuItems(this.$store)
      },
      ...breadcrumb,
      {
        title: s(this.$store).landingPage.landingPage.title,
        location: ''
      }
    ]
  }

  get isShowPaginate (): boolean {
    return s(this.$store).landingPage.pageCount > 1
  }

  get ferchLocation () {
    const route = { ...this.$route }
    const targetPage = s(this.$store).landingPage.page + 2
    const query = route.query
    return {
      path: route.path,
      query: {
        ...query,
        page: targetPage.toString()
      }
    }
  }

  renderPaginate () {
    if (this.isShowPaginate) {
      return (
        <div class="entity-list-block__content-paginate">
          <LinkPaginate {...{
            props: {
              pageCount: s(this.$store).landingPage.pageCount,
              selected: s(this.$store).landingPage.page
            }
          }} />
        </div>
      )
    }
  }

  renderLoadButton () {
    if (s(this.$store).landingPage.page < s(this.$store).landingPage.pageCount - 1) {
      return (
        <div class="entity-list-block__content-fetch">
          <nuxt-link {...{
            class: 'entity-list-block__content-fetch-button',
            props: {
              to: this.ferchLocation
            },
            nativeOn: {
              click: () => s(this.$store).landingPage.enableLoadMore()
            }
          }}>
            Загрузить еще
          </nuxt-link>
        </div>
      )
    }
  }

  renderLandingPageInfo() {
    if (s(this.$store).landingPage.showInfo) {
      return (
        <div class="catalog-page__category-info">
          <div class="catalog-page__category-info-container">
            {
              this.isShow

                ? <div domPropsInnerHTML={s(this.$store).landingPage.landingPage.HTMLContent ?? s(this.$store).landingPage.landingPage.textContent}></div>
                : <truncate-collapsed {...{
                  props: {
                    length: 1000,
                    clamp: 'Показать еще',
                    type: 'html',
                    text: s(this.$store).landingPage.landingPage.HTMLContent ?? s(this.$store).landingPage.landingPage.textContent,
                    less: 'Скрыть',
                    'action-class': 'catalog-page__show-more'
                  }
                }} />
            }
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <div class="catalog-page">
        <div class="catalog-page__header">
          <PageHeader {...{
            props: {
              typeHeader: HeaderType.LandingPage,
              breadcrumb: this.breadcrumb
            }
          }} />
        </div>
        <div class="catalog-page__content">
          <div class="entity-list-block">
            <div class="entity-list-block__content">
              <div class="entity-list-block__content-row">
                <div class="entity-list-block__content-col-filter">
                  <FilterProduct {...{
                    props: {
                      store: s(this.$store).landingPageFilter
                    }
                  }} />
                </div>
                <div {...{
                  class: {
                    'entity-list-block__content-col-product': true,
                    'entity-list-block__content-col-product-adaptive': s(this.$store).categoryPage.category.isPreset
                  }
                }}>
                  {/* <TagsCloud /> */}
                  <div class="entity-list-block__content-product-row">
                    <div {...{
                      class: {
                        'entity-list-block__content-product': true,
                        'entity-list-block__content-product-adaptive': s(this.$store).categoryPage.category.isPreset
                      }
                    }}>
                      <ProductList {...{
                        props: {
                          products: s(this.$store).landingPage.landingPage?.products ?? [],
                          count: s(this.$store).landingPage.landingPage?.count?.toString(),
                          isShowAds: false
                        }
                      }} />
                    </div>
                    {this.renderLoadButton()}
                    {this.renderPaginate()}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.renderLandingPageInfo()}
        </div>
      </div>
    )
  }
}
